import axios from "../api/axios";
import { useEffect, useState } from "react";
import Category from "../Category";
import LoadingSpinner from "../LoadingSpinner";
import useSWR from "swr";
import { Helmet } from "react-helmet";
import Cats from "./Cats";
import { useParams } from "react-router-dom";
import Dish from "./Dish";
import LineLoading from "../LineLoading";

const fetcher = (url) => axios.get(url).then((res) => res.data);

export default function Home() {
	const [loading, setLoading] = useState(true);

	const [special, setSpecial] = useState(true);
	const [type, setType] = useState(null);

	const [search, setSearch] = useState("");

	const params = useParams();

	const { data, error } = useSWR(
		`${
			process.env.REACT_APP_API
				? process.env.REACT_APP_API
				: "http://127.0.0.1:8000/api"
		}/get-dishes?res=${params.rid}`,
		fetcher
	);

	const { data: s_data, error: s_error } = useSWR(
		`${
			process.env.REACT_APP_API
				? process.env.REACT_APP_API
				: "http://127.0.0.1:8000/api"
		}/special-dishes?res=${params.rid}`,
		fetcher
	);

	const changeType = (arg) => {
		if (arg === type) setType(null);
		else setType(arg);
	};

	useEffect(() => {
		setLoading(!error && !data);
	}, [data, error]);

	useEffect(() => {
		setSpecial(!s_error && !s_data);
	}, [s_data, s_error]);

	return (
		<>
			<Helmet>
				<title>Order Your Food</title>
			</Helmet>

			{loading && <LoadingSpinner asOverlay />}
			<section id="fda_header_bar" className="col-12 sha2">
				<div className="row fda_search_row">
					<div className="col-12">
						<i className="fa fa-search"></i>
						<input
							type="search"
							className="fda_ip_search sha"
							placeholder="Search"
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
					</div>
				</div>

				<div className="pt-3 fix-filter">
					<button
						type="button"
						onClick={changeType.bind(this, "Vegetarian")}
						className={`${
							type === "Vegetarian" ? "success" : "unsuccess"
						} btn btn-sm bttn`}
					>
						<i className="fa fa-leaf"></i>&nbsp;&nbsp;Veg
					</button>
					<button
						type="button"
						onClick={changeType.bind(this, "Non-Vegetarian")}
						className={`${
							type === "Non-Vegetarian" ? "success" : "unsuccess"
						} btn btn-sm bttn`}
					>
						<i className="fa-solid fa-drumstick-bite"></i>&nbsp;&nbsp;Non-Veg
					</button>
				</div>
			</section>

			<div className="container-fluid">
				<div id="fda_app" className="row">
					<section id="fda_product_tile" className="col-12 hid">
						{special ? (
							<LineLoading />
						) : (
							s_data.data.length > 0 && (
								<>
									<p color="#363636" className="littleline">
										Today's Special
									</p>

									<div className="row fda_food_row">
										{s_data.data.map((d) => (
											<Dish key={d.id} dish={d} />
										))}
									</div>
								</>
							)
						)}
					</section>
					{!loading && (
						<>
							{data.data.map((d) => {
								return (
									<Category
										key={d.id}
										category={d}
										search={search}
										type={type}
									/>
								);
							})}
						</>
					)}
				</div>
			</div>
			{!loading && <Cats categories={data.data} />}
		</>
	);
}
